module.exports = __webpack_public_path__ + "static/img/on-4p.084577b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newHome/village/on-4p.png
// module id = uAi5
// module chunks = 1